<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <div class="ckeditor-container">
              <div class="editor-label">
                {{ 'global.description' | transloco }}
              </div>
              <ckeditor
                class="ckeditor"
                [editor]="editor"
                [config]="ckconfig"
                [formControl]="getFormControl('description')"
                (change)="onEditorChange($event)"
              ></ckeditor>
              <div class="char-counter" [ngClass]="{ error: charCounter > charMax }">
                {{ charCounter }}
              </div>
              @if (getFormControl('description').invalid) {
                <div class="mat-error">
                  @if (getFormControl('description').errors.charMax) {
                    {{ 'form.error.description_too_long' | transloco }}
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  }
</div>
